import { getProject } from 'src/redux/slices/project/endpoints'

import { Divider, Grid, Typography } from '@material-ui/core'

///// Component
const ProjectHeader: React.FC = () => {
  const { data: project, isLoading } = getProject.useQuery('')

  if (isLoading || !project)
    return <Typography style={{ marginTop: '2rem' }}>Loading...</Typography>

  return (
    <>
      <Typography style={{ marginTop: '2rem', marginBottom: '1rem' }} variant='h4'>
        {project.title}
      </Typography>
      {project.countryISO3 && <Divider />}
      <Grid container justifyContent='flex-start' alignItems='center' spacing={1}>
        <Grid item xs={12}></Grid>
        {project.countryISO3 && (
          <Grid container item xs={12} justifyContent='center' alignItems='center' spacing={2}>
            <Grid container item xs={4} justifyContent='center' alignItems='center' spacing={1}>
              <Grid item>
                <Typography variant='overline'>Location: </Typography>
              </Grid>
              <Grid item>
                <Typography variant='body2'>{project.countryISO3}</Typography>
              </Grid>
            </Grid>
            <Grid container item xs={4} justifyContent='center' alignItems='center' spacing={1}>
              <Grid item>
                <Typography variant='overline'>Lat/Lon: </Typography>
              </Grid>
              <Grid item>
                <Typography variant='body2'>
                  ({project.lat}, {project.lon})
                </Typography>
              </Grid>
            </Grid>
            <Grid container item xs={4} justifyContent='center' alignItems='center' spacing={1}>
              <Grid item>
                <Typography variant='overline'>
                  Climate Zone
                  {(project.climateZones ?? []).length > 1 ? 's' : ''}:{' '}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant='body2'>{project.climateZones?.join(', ')}</Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default ProjectHeader
